namespace Matrix.Workflow {
    export interface TaskRow {
        TaskId?: number;
        WorkflowCode?: string;
        TaskCode?: string;
        SequenceNumber?: number;
        Description?: string;
        ReadPermissions?: string;
        WritePermissions?: string;
        Properties?: string;
        Class1Name?: string;
        Class1?: string;
        Class2Name?: string;
        Class2?: string;
        Class3Name?: string;
        Class3?: string;
        Class4Name?: string;
        Class4?: string;
        Class5Name?: string;
        Class5?: string;
        Key1Name?: string;
        Key1?: string;
        Key2Name?: string;
        Key2?: string;
        Key3Name?: string;
        Key3?: string;
        Key4Name?: string;
        Key4?: string;
        Key5Name?: string;
        Key5?: string;
        C1Name?: string;
        C1?: string;
        C2Name?: string;
        C2?: string;
        C3Name?: string;
        C3?: string;
        C4Name?: string;
        C4?: string;
        C5Name?: string;
        C5?: string;
        C6Name?: string;
        C6?: string;
        C7Name?: string;
        C7?: string;
        C8Name?: string;
        C8?: string;
        C9Name?: string;
        C9?: string;
        C10Name?: string;
        C10?: string;
        B1Name?: string;
        B1?: boolean;
        B2Name?: string;
        B2?: boolean;
        B3Name?: string;
        B3?: boolean;
        B4Name?: string;
        B4?: boolean;
        B5Name?: string;
        B5?: boolean;
        B6Name?: string;
        B6?: boolean;
        B7Name?: string;
        B7?: boolean;
        B8Name?: string;
        B8?: boolean;
        B9Name?: string;
        B9?: boolean;
        B10Name?: string;
        B10?: boolean;
        N1Name?: string;
        N1?: number;
        N2Name?: string;
        N2?: number;
        N3Name?: string;
        N3?: number;
        N4Name?: string;
        N4?: number;
        N5Name?: string;
        N5?: number;
        N6Name?: string;
        N6?: number;
        N7Name?: string;
        N7?: number;
        N8Name?: string;
        N8?: number;
        N9Name?: string;
        N9?: number;
        N10Name?: string;
        N10?: number;
        F1Name?: string;
        F1?: number;
        F2Name?: string;
        F2?: number;
        F3Name?: string;
        F3?: number;
        F4Name?: string;
        F4?: number;
        F5Name?: string;
        F5?: number;
        F6Name?: string;
        F6?: number;
        F7Name?: string;
        F7?: number;
        F8Name?: string;
        F8?: number;
        F9Name?: string;
        F9?: number;
        F10Name?: string;
        F10?: number;
        D1Name?: string;
        D1?: string;
        D2Name?: string;
        D2?: string;
        D3Name?: string;
        D3?: string;
        D4Name?: string;
        D4?: string;
        D5Name?: string;
        D5?: string;
        Txt1Name?: string;
        Txt1?: string;
        Txt2Name?: string;
        Txt2?: string;
        Txt3Name?: string;
        Txt3?: string;
        Txt4Name?: string;
        Txt4?: string;
        Txt5Name?: string;
        Txt5?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        WorkflowDescription?: string;
        WorkflowIsEnabled?: boolean;
        WorkflowReadPermissions?: string;
        WorkflowWritePermissions?: string;
        WorkflowArchivePolicy?: string;
        WorkflowProperties?: string;
        WorkflowClass1Name?: string;
        WorkflowClass1?: string;
        WorkflowClass2Name?: string;
        WorkflowClass2?: string;
        WorkflowClass3Name?: string;
        WorkflowClass3?: string;
        WorkflowClass4Name?: string;
        WorkflowClass4?: string;
        WorkflowClass5Name?: string;
        WorkflowClass5?: string;
        WorkflowKey1Name?: string;
        WorkflowKey1?: string;
        WorkflowKey2Name?: string;
        WorkflowKey2?: string;
        WorkflowKey3Name?: string;
        WorkflowKey3?: string;
        WorkflowKey4Name?: string;
        WorkflowKey4?: string;
        WorkflowKey5Name?: string;
        WorkflowKey5?: string;
        WorkflowC1Name?: string;
        WorkflowC1?: string;
        WorkflowC2Name?: string;
        WorkflowC2?: string;
        WorkflowC3Name?: string;
        WorkflowC3?: string;
        WorkflowC4Name?: string;
        WorkflowC4?: string;
        WorkflowC5Name?: string;
        WorkflowC5?: string;
        WorkflowC6Name?: string;
        WorkflowC6?: string;
        WorkflowC7Name?: string;
        WorkflowC7?: string;
        WorkflowC8Name?: string;
        WorkflowC8?: string;
        WorkflowC9Name?: string;
        WorkflowC9?: string;
        WorkflowC10Name?: string;
        WorkflowC10?: string;
        WorkflowB1Name?: string;
        WorkflowB1?: boolean;
        WorkflowB2Name?: string;
        WorkflowB2?: boolean;
        WorkflowB3Name?: string;
        WorkflowB3?: boolean;
        WorkflowB4Name?: string;
        WorkflowB4?: boolean;
        WorkflowB5Name?: string;
        WorkflowB5?: boolean;
        WorkflowB6Name?: string;
        WorkflowB6?: boolean;
        WorkflowB7Name?: string;
        WorkflowB7?: boolean;
        WorkflowB8Name?: string;
        WorkflowB8?: boolean;
        WorkflowB9Name?: string;
        WorkflowB9?: boolean;
        WorkflowB10Name?: string;
        WorkflowB10?: boolean;
        WorkflowN1Name?: string;
        WorkflowN1?: number;
        WorkflowN2Name?: string;
        WorkflowN2?: number;
        WorkflowN3Name?: string;
        WorkflowN3?: number;
        WorkflowN4Name?: string;
        WorkflowN4?: number;
        WorkflowN5Name?: string;
        WorkflowN5?: number;
        WorkflowN6Name?: string;
        WorkflowN6?: number;
        WorkflowN7Name?: string;
        WorkflowN7?: number;
        WorkflowN8Name?: string;
        WorkflowN8?: number;
        WorkflowN9Name?: string;
        WorkflowN9?: number;
        WorkflowN10Name?: string;
        WorkflowN10?: number;
        WorkflowF1Name?: string;
        WorkflowF1?: number;
        WorkflowF2Name?: string;
        WorkflowF2?: number;
        WorkflowF3Name?: string;
        WorkflowF3?: number;
        WorkflowF4Name?: string;
        WorkflowF4?: number;
        WorkflowF5Name?: string;
        WorkflowF5?: number;
        WorkflowF6Name?: string;
        WorkflowF6?: number;
        WorkflowF7Name?: string;
        WorkflowF7?: number;
        WorkflowF8Name?: string;
        WorkflowF8?: number;
        WorkflowF9Name?: string;
        WorkflowF9?: number;
        WorkflowF10Name?: string;
        WorkflowF10?: number;
        WorkflowD1Name?: string;
        WorkflowD1?: string;
        WorkflowD2Name?: string;
        WorkflowD2?: string;
        WorkflowD3Name?: string;
        WorkflowD3?: string;
        WorkflowD4Name?: string;
        WorkflowD4?: string;
        WorkflowD5Name?: string;
        WorkflowD5?: string;
        WorkflowTxt1Name?: string;
        WorkflowTxt1?: string;
        WorkflowTxt2Name?: string;
        WorkflowTxt2?: string;
        WorkflowTxt3Name?: string;
        WorkflowTxt3?: string;
        WorkflowTxt4Name?: string;
        WorkflowTxt4?: string;
        WorkflowTxt5Name?: string;
        WorkflowTxt5?: string;
        WorkflowRowId?: number;
        WorkflowVersion?: number;
        WorkflowCreatedBy?: string;
        WorkflowCreatedWhen?: string;
        WorkflowUpdatedBy?: string;
        WorkflowUpdatedWhen?: string;
    }

    export namespace TaskRow {
        export const idProperty = 'TaskId';
        export const nameProperty = 'TaskCode';
        export const localTextPrefix = 'Workflow.Task';
        export const lookupKey = 'Workflow.Task';

        export function getLookup(): Q.Lookup<TaskRow> {
            return Q.getLookup<TaskRow>('Workflow.Task');
        }
        export const deletePermission = 'DataAdmin:Task';
        export const insertPermission = 'DataAdmin:Task';
        export const readPermission = 'Read:Task';
        export const updatePermission = 'DataAdmin:Task';

        export declare const enum Fields {
            TaskId = "TaskId",
            WorkflowCode = "WorkflowCode",
            TaskCode = "TaskCode",
            SequenceNumber = "SequenceNumber",
            Description = "Description",
            ReadPermissions = "ReadPermissions",
            WritePermissions = "WritePermissions",
            Properties = "Properties",
            Class1Name = "Class1Name",
            Class1 = "Class1",
            Class2Name = "Class2Name",
            Class2 = "Class2",
            Class3Name = "Class3Name",
            Class3 = "Class3",
            Class4Name = "Class4Name",
            Class4 = "Class4",
            Class5Name = "Class5Name",
            Class5 = "Class5",
            Key1Name = "Key1Name",
            Key1 = "Key1",
            Key2Name = "Key2Name",
            Key2 = "Key2",
            Key3Name = "Key3Name",
            Key3 = "Key3",
            Key4Name = "Key4Name",
            Key4 = "Key4",
            Key5Name = "Key5Name",
            Key5 = "Key5",
            C1Name = "C1Name",
            C1 = "C1",
            C2Name = "C2Name",
            C2 = "C2",
            C3Name = "C3Name",
            C3 = "C3",
            C4Name = "C4Name",
            C4 = "C4",
            C5Name = "C5Name",
            C5 = "C5",
            C6Name = "C6Name",
            C6 = "C6",
            C7Name = "C7Name",
            C7 = "C7",
            C8Name = "C8Name",
            C8 = "C8",
            C9Name = "C9Name",
            C9 = "C9",
            C10Name = "C10Name",
            C10 = "C10",
            B1Name = "B1Name",
            B1 = "B1",
            B2Name = "B2Name",
            B2 = "B2",
            B3Name = "B3Name",
            B3 = "B3",
            B4Name = "B4Name",
            B4 = "B4",
            B5Name = "B5Name",
            B5 = "B5",
            B6Name = "B6Name",
            B6 = "B6",
            B7Name = "B7Name",
            B7 = "B7",
            B8Name = "B8Name",
            B8 = "B8",
            B9Name = "B9Name",
            B9 = "B9",
            B10Name = "B10Name",
            B10 = "B10",
            N1Name = "N1Name",
            N1 = "N1",
            N2Name = "N2Name",
            N2 = "N2",
            N3Name = "N3Name",
            N3 = "N3",
            N4Name = "N4Name",
            N4 = "N4",
            N5Name = "N5Name",
            N5 = "N5",
            N6Name = "N6Name",
            N6 = "N6",
            N7Name = "N7Name",
            N7 = "N7",
            N8Name = "N8Name",
            N8 = "N8",
            N9Name = "N9Name",
            N9 = "N9",
            N10Name = "N10Name",
            N10 = "N10",
            F1Name = "F1Name",
            F1 = "F1",
            F2Name = "F2Name",
            F2 = "F2",
            F3Name = "F3Name",
            F3 = "F3",
            F4Name = "F4Name",
            F4 = "F4",
            F5Name = "F5Name",
            F5 = "F5",
            F6Name = "F6Name",
            F6 = "F6",
            F7Name = "F7Name",
            F7 = "F7",
            F8Name = "F8Name",
            F8 = "F8",
            F9Name = "F9Name",
            F9 = "F9",
            F10Name = "F10Name",
            F10 = "F10",
            D1Name = "D1Name",
            D1 = "D1",
            D2Name = "D2Name",
            D2 = "D2",
            D3Name = "D3Name",
            D3 = "D3",
            D4Name = "D4Name",
            D4 = "D4",
            D5Name = "D5Name",
            D5 = "D5",
            Txt1Name = "Txt1Name",
            Txt1 = "Txt1",
            Txt2Name = "Txt2Name",
            Txt2 = "Txt2",
            Txt3Name = "Txt3Name",
            Txt3 = "Txt3",
            Txt4Name = "Txt4Name",
            Txt4 = "Txt4",
            Txt5Name = "Txt5Name",
            Txt5 = "Txt5",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            WorkflowDescription = "WorkflowDescription",
            WorkflowIsEnabled = "WorkflowIsEnabled",
            WorkflowReadPermissions = "WorkflowReadPermissions",
            WorkflowWritePermissions = "WorkflowWritePermissions",
            WorkflowArchivePolicy = "WorkflowArchivePolicy",
            WorkflowProperties = "WorkflowProperties",
            WorkflowClass1Name = "WorkflowClass1Name",
            WorkflowClass1 = "WorkflowClass1",
            WorkflowClass2Name = "WorkflowClass2Name",
            WorkflowClass2 = "WorkflowClass2",
            WorkflowClass3Name = "WorkflowClass3Name",
            WorkflowClass3 = "WorkflowClass3",
            WorkflowClass4Name = "WorkflowClass4Name",
            WorkflowClass4 = "WorkflowClass4",
            WorkflowClass5Name = "WorkflowClass5Name",
            WorkflowClass5 = "WorkflowClass5",
            WorkflowKey1Name = "WorkflowKey1Name",
            WorkflowKey1 = "WorkflowKey1",
            WorkflowKey2Name = "WorkflowKey2Name",
            WorkflowKey2 = "WorkflowKey2",
            WorkflowKey3Name = "WorkflowKey3Name",
            WorkflowKey3 = "WorkflowKey3",
            WorkflowKey4Name = "WorkflowKey4Name",
            WorkflowKey4 = "WorkflowKey4",
            WorkflowKey5Name = "WorkflowKey5Name",
            WorkflowKey5 = "WorkflowKey5",
            WorkflowC1Name = "WorkflowC1Name",
            WorkflowC1 = "WorkflowC1",
            WorkflowC2Name = "WorkflowC2Name",
            WorkflowC2 = "WorkflowC2",
            WorkflowC3Name = "WorkflowC3Name",
            WorkflowC3 = "WorkflowC3",
            WorkflowC4Name = "WorkflowC4Name",
            WorkflowC4 = "WorkflowC4",
            WorkflowC5Name = "WorkflowC5Name",
            WorkflowC5 = "WorkflowC5",
            WorkflowC6Name = "WorkflowC6Name",
            WorkflowC6 = "WorkflowC6",
            WorkflowC7Name = "WorkflowC7Name",
            WorkflowC7 = "WorkflowC7",
            WorkflowC8Name = "WorkflowC8Name",
            WorkflowC8 = "WorkflowC8",
            WorkflowC9Name = "WorkflowC9Name",
            WorkflowC9 = "WorkflowC9",
            WorkflowC10Name = "WorkflowC10Name",
            WorkflowC10 = "WorkflowC10",
            WorkflowB1Name = "WorkflowB1Name",
            WorkflowB1 = "WorkflowB1",
            WorkflowB2Name = "WorkflowB2Name",
            WorkflowB2 = "WorkflowB2",
            WorkflowB3Name = "WorkflowB3Name",
            WorkflowB3 = "WorkflowB3",
            WorkflowB4Name = "WorkflowB4Name",
            WorkflowB4 = "WorkflowB4",
            WorkflowB5Name = "WorkflowB5Name",
            WorkflowB5 = "WorkflowB5",
            WorkflowB6Name = "WorkflowB6Name",
            WorkflowB6 = "WorkflowB6",
            WorkflowB7Name = "WorkflowB7Name",
            WorkflowB7 = "WorkflowB7",
            WorkflowB8Name = "WorkflowB8Name",
            WorkflowB8 = "WorkflowB8",
            WorkflowB9Name = "WorkflowB9Name",
            WorkflowB9 = "WorkflowB9",
            WorkflowB10Name = "WorkflowB10Name",
            WorkflowB10 = "WorkflowB10",
            WorkflowN1Name = "WorkflowN1Name",
            WorkflowN1 = "WorkflowN1",
            WorkflowN2Name = "WorkflowN2Name",
            WorkflowN2 = "WorkflowN2",
            WorkflowN3Name = "WorkflowN3Name",
            WorkflowN3 = "WorkflowN3",
            WorkflowN4Name = "WorkflowN4Name",
            WorkflowN4 = "WorkflowN4",
            WorkflowN5Name = "WorkflowN5Name",
            WorkflowN5 = "WorkflowN5",
            WorkflowN6Name = "WorkflowN6Name",
            WorkflowN6 = "WorkflowN6",
            WorkflowN7Name = "WorkflowN7Name",
            WorkflowN7 = "WorkflowN7",
            WorkflowN8Name = "WorkflowN8Name",
            WorkflowN8 = "WorkflowN8",
            WorkflowN9Name = "WorkflowN9Name",
            WorkflowN9 = "WorkflowN9",
            WorkflowN10Name = "WorkflowN10Name",
            WorkflowN10 = "WorkflowN10",
            WorkflowF1Name = "WorkflowF1Name",
            WorkflowF1 = "WorkflowF1",
            WorkflowF2Name = "WorkflowF2Name",
            WorkflowF2 = "WorkflowF2",
            WorkflowF3Name = "WorkflowF3Name",
            WorkflowF3 = "WorkflowF3",
            WorkflowF4Name = "WorkflowF4Name",
            WorkflowF4 = "WorkflowF4",
            WorkflowF5Name = "WorkflowF5Name",
            WorkflowF5 = "WorkflowF5",
            WorkflowF6Name = "WorkflowF6Name",
            WorkflowF6 = "WorkflowF6",
            WorkflowF7Name = "WorkflowF7Name",
            WorkflowF7 = "WorkflowF7",
            WorkflowF8Name = "WorkflowF8Name",
            WorkflowF8 = "WorkflowF8",
            WorkflowF9Name = "WorkflowF9Name",
            WorkflowF9 = "WorkflowF9",
            WorkflowF10Name = "WorkflowF10Name",
            WorkflowF10 = "WorkflowF10",
            WorkflowD1Name = "WorkflowD1Name",
            WorkflowD1 = "WorkflowD1",
            WorkflowD2Name = "WorkflowD2Name",
            WorkflowD2 = "WorkflowD2",
            WorkflowD3Name = "WorkflowD3Name",
            WorkflowD3 = "WorkflowD3",
            WorkflowD4Name = "WorkflowD4Name",
            WorkflowD4 = "WorkflowD4",
            WorkflowD5Name = "WorkflowD5Name",
            WorkflowD5 = "WorkflowD5",
            WorkflowTxt1Name = "WorkflowTxt1Name",
            WorkflowTxt1 = "WorkflowTxt1",
            WorkflowTxt2Name = "WorkflowTxt2Name",
            WorkflowTxt2 = "WorkflowTxt2",
            WorkflowTxt3Name = "WorkflowTxt3Name",
            WorkflowTxt3 = "WorkflowTxt3",
            WorkflowTxt4Name = "WorkflowTxt4Name",
            WorkflowTxt4 = "WorkflowTxt4",
            WorkflowTxt5Name = "WorkflowTxt5Name",
            WorkflowTxt5 = "WorkflowTxt5",
            WorkflowRowId = "WorkflowRowId",
            WorkflowVersion = "WorkflowVersion",
            WorkflowCreatedBy = "WorkflowCreatedBy",
            WorkflowCreatedWhen = "WorkflowCreatedWhen",
            WorkflowUpdatedBy = "WorkflowUpdatedBy",
            WorkflowUpdatedWhen = "WorkflowUpdatedWhen"
        }
    }
}
